import { createContext } from 'react'

import { FEATURE_TYPES } from 'featureFlagsConfig'

export type FlagsContextValue = {
  flags: { [key in FEATURE_TYPES]: boolean }
}

export const FlagsContext = createContext<FlagsContextValue>(null!)
